import objectFitImages from 'object-fit-images';
import 'lazysizes';
import ScrollOut from "scroll-out";

ScrollOut({
  once: true,
  threshold: 0.2
});

document.addEventListener('DOMContentLoaded', () => {
  function toggleMenu() {
    const open = document.querySelector('.Site').classList.toggle('is-menu-open');
    document.querySelector('.SiteMenuButton-label').innerText = open ? 'Close Menu' : 'Open Menu';
  }

  document.querySelector('.SiteHeader-menu').addEventListener('click', () => {
    toggleMenu();
  });

  const menu = document.querySelector('.SiteMenu');
  menu.addEventListener('click', e => {
    if (e.target === menu) {
      toggleMenu();
    }
  })
});

//* objectfit polyfill =================================================== */

objectFitImages();
